/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useMemo } from "react";
import ReactPlayer from "react-player";
import { Carousel } from "react-responsive-carousel";
import { useTranslate } from "../../../translate";
import * as styles from "./styles";
import { decorateRichText } from "../utils";

const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;
const configurableProps = {
    renderItem: customRenderItem,
    showArrows: true,
    showStatus: false,
    showIndicators: true,
    infiniteLoop: true,
    showThumbs: false,
    useKeyboardArrows: true,
    autoPlay: false,
    stopOnHover: true,
    swipeable: true,
    dynamicHeight: false,
    emulateTouch: true,
    thumbWidth: 0,
    selectedItem: 0,
    interval: 4000,
    transitionTime: 150,
    swipeScrollTolerance: 5,
};

function ItineraryPlaceStartCard(props) {
    const { stop, className, title, description, stopsCount, ...attrs } = props;
    const translate = useTranslate();
    const carousel = useMemo(
        () =>
            stop.gallery.map((item, index) => {
                if (item.type === "video") {
                    return () => (
                        <ReactPlayer playing={false} width="100%" url={item.url} key={`${item.url}${index}`} />
                    );
                }
                return () => (
                    <img src={item?.medium2x} alt={translate(stop, "name")} key={`${item?.medium2x}${index}`} />
                );
            }),
        [translate, stop],
    );
    const isSingleCarousel = carousel.length <= 1;
    const newDescription = useMemo(() => decorateRichText(description), [description]);

    return (
        <section css={styles.container} className={className} {...attrs}>
            <header css={styles.header}>
                <h3 css={styles.title}>{title}</h3>
                <div css={styles.subTitle}>
                    <i className="trpr__icon-marker"></i>
                    <span>Next {stopsCount} stops</span>
                </div>
            </header>
            <div css={styles.content} dangerouslySetInnerHTML={{ __html: newDescription }}></div>
            <Carousel css={styles.carousel({ isSingleCarousel })} {...configurableProps}>
                {carousel.map((MediaType, index) => (
                    <MediaType key={index} />
                ))}
            </Carousel>
        </section>
    );
}

export default ItineraryPlaceStartCard;
